var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-alignment-icon",class:_vm.variation,style:(`--width: ${_vm.width}px; --height: ${_vm.height}px; --line-height: ${_vm.lineHeight}px; --color: ${_vm.color}`)},[_c('div',{staticClass:"stroke-1"}),_vm._v(" "),_c('div',{staticClass:"stroke-2"}),_vm._v(" "),_c('div',{staticClass:"stroke-3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }